import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=571aa046&scoped=true&"
import script from "./sales.js?vue&type=script&lang=js&"
export * from "./sales.js?vue&type=script&lang=js&"
import style0 from "./sales.css?vue&type=style&index=0&id=571aa046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571aa046",
  null
  
)

export default component.exports